export const pinsPage = {
  header: {
    today: 'Job PINs • %date% (Today) ',
  },
  pinCard: {
    pinType: {
      start: 'Start',
      complete: 'Complete',
    },
  },
  noResults: 'No Jobs Today'
};
